import { preciseDivide } from '@slot-nx/core'
import { BitmapText, Container, Sprite } from '@pixi/react'
import { gameConfig } from '../../../config'
import { SpinType } from '../../../domain/betDetail/store/betDetailStore'
import { SymbolType } from '../../../domain/game/enum/SymbolType'
import { getSymbolImg } from '../../../domain/game/util/gameUtil'
import { DropDetail } from '../../../domain/betDetail/models/BetDetailResponse'

interface TableDetailProps {
  currentGameDetail: DropDetail
  spinType: SpinType
  triggerGameDetail: { type: number, count: number, payout: number }[]
}

export const TableDetail = ({ currentGameDetail, spinType, triggerGameDetail }: TableDetailProps) => {
  const winPositions = currentGameDetail.totalWinPositions
  const isExpand = currentGameDetail.reelTable[0].length === 6
  const isBonusGame = spinType === SpinType.BonusSpin

  const isUseMultiplier = currentGameDetail.basePayout > 0 && currentGameDetail.totalMultiplier > 1
  return (
    <Container name="TableDetail">
      <Container name="MGTable" x={187} y={520}>
        <Sprite name="Img" width={810} height={600} x={350} y={200} anchor={[0.5]} image={isExpand ? 'image_detail_table' : 'image_detail_expandtable'} />
        {isBonusGame && (
          <Container x={350} y={-90} pivot={[0.5, 0.5]}>
            <Sprite name="totalMultiplier" width={182} height={139} x={0} y={0} anchor={[0.5]} image="image_totalMultiplier" tint={isUseMultiplier ? 0xFFFFFF : 0x888888} />
            <BitmapText name="currentRoundNum" text={currentGameDetail.accMultiplier.toString()} x={-2.5} y={-10} anchor={[0.5, 0.5]} style={{ fontName: 'fontB', fontSize: 24 }} tint={isUseMultiplier ? 0xFFFFFF : 0x888888} />
          </Container>
        )}

        {currentGameDetail.reelTable.map((reel, reelIndex) => {
          return reel.map((symbol, symbolIndex) => {
            const reelSymbolCount = reel.length
            const symbolHeight = preciseDivide(gameConfig.containerHegiht, reelSymbolCount)
            const isWinSymbol = winPositions[reelIndex]?.includes(symbolIndex)
            const isMultiplier = symbol.type === SymbolType.S1
            const isTriggerSymbol = triggerGameDetail.some(item => item.type === symbol.type)
            const tint = (isWinSymbol || isTriggerSymbol) ? 0xffffff : 0x777777
            return (
              <Container name="Symbol" x={(reelIndex * gameConfig.nodeWidth * 0.775)} y={(symbolIndex * symbolHeight * 0.8) - 30} key={`${reelIndex}_${symbolIndex}`}>
                <Sprite name="Img" x={0} y={0} image={getSymbolImg(symbol)} scale={0.7} tint={tint} />
                <BitmapText
                  name="multiplier"
                  text={String(isMultiplier ? `${symbol.multiplier}X` : '')}
                  x={gameConfig.nodeWidth / 2 * 0.7}
                  y={gameConfig.nodeHeight / 2 + 5}
                  style={{ fontName: 'fontB', fontSize: 20 }}
                  anchor={[0.5, 2.5]}
                  scale={0.7}
                  visible={isMultiplier}
                  tint={tint}
                />
              </Container>
            )
          })
        })}
      </Container>
    </Container>
  )
}
